export default __webpack_public_path__ + "static/media/TyperecordDesactive.b19101a6.svg";